import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { useEffect, useRef, useState } from 'react';
import pauseIcon from '../../images/icon-pause.svg';
import { MEDIA_TYPE } from '../../utils/constants';
import Carousel from '../Carousel';
import Image from '../Image';
import './styles.scss';

const Hero = ({ mediaSource, mediaType, guidSrc, textOverlay, className }) => {
  const [loaded, setLoaded] = useState(false);
  const [paused, setPaused] = useState(false);
  const videoRef = useRef(null);
  const isVideo = mediaType && Object.values(MEDIA_TYPE).includes(mediaType);
  const isMultiImage = Array.isArray(mediaSource);

  /**
   * useEffect used to delay the loading of video so other
   * images can start downloaded before the video downloads.
   * This is needed for iPad, because Safari on iOS 12 will
   * try to load the video and block all other image downloads,
   * so we render the video AFTER load to allow other images to
   * start their download first.
   */
  useEffect(() => {
    setLoaded(true);
  }, []);

  const handlePause = () => {
    if (paused) {
      videoRef.current.play();
      setPaused(false);
    } else {
      videoRef.current.pause();
      setPaused(true);
    }
  };

  if (isVideo) {
    return (
      <div className={classNames('hero', className)}>
        <div className="hero__skew-shape"></div>
        <div className="hero__video">
          {loaded && (
            //<AzureVideo
            // videoSrc="https://primaryusproduction-use2.streaming.media.azure.net/94f1776a-5da0-4187-b5fa-948c4d18bca3/nielsen-homepag.ism/manifest%28format%3Dm3u8-aapl%29"
            // poster={videoBgImage}
            //controls={false}
            //loop
            //muted
            //autoplay
            //pause={paused}
            ///>
            // <Video guidSrc={guidSrc} autoplay={true} />
            <video ref={videoRef} muted autoPlay>
              <source
                src="https://cdn-media.discoveryeducation.com/aeb29dff-aafd-4d3b-9bc6-9e8d4b5a9d9f/downloads/960x540_805478/4517492e-db3e-4f10-aa55-5b55716eed75/4517492e-db3e-4f10-aa55-5b55716eed75_960x540_805478.mp4"
                type="video/mp4"
              />
            </video>
          )}
        </div>
        {textOverlay}
        <div className="hero__video-pause" onClick={handlePause}>
          {paused ? (
            <span className="play-hero-video" />
          ) : (
            <img src={pauseIcon} alt="pauseIcon" />
          )}
        </div>
      </div>
    );
  } else if (isMultiImage) {
    return (
      <div className={classNames('hero', className)}>
        <Carousel
          headingClassOverride={'mb-0'}
          imageContainerClassOverride={'mb-0'}
          slideClassOverride={'mb-0'}
          settings={{ fade: true, className: 'hero__inner-slider-div' }}
          slides={mediaSource}
        />
        {textOverlay}
      </div>
    );
  } else {
    return (
      <div className={classNames('hero', className)}>
        <Image filename={mediaSource} className="hero__img" />
        {textOverlay}
      </div>
    );
  }
};

Hero.defaultProps = {
  textOverlay: null,
  className: null,
};

Hero.propTypes = {
  /** A path to video or a filename for an image (using the Image Component)
   * or an array of objects for multi image slider
   */
  mediaSource: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(
      PropTypes.shape({
        image: PropTypes.string,
        title: PropTypes.string,
        text: PropTypes.string,
      })
    ),
  ]).isRequired,
  /** The type used for the video */
  mediaType: PropTypes.oneOf(Object.values(MEDIA_TYPE)),
  /** Text overlay for the image/video. The hero-text-overlay-container-defaults mixin
   * contains the default CSS for a left side text overlay.
   */
  textOverlay: PropTypes.object,
  /** A custom class name */
  classNames: PropTypes.string,
};

export default Hero;
